import { CrudModel } from "./_crud";

export class QualificationAppModel extends CrudModel {
	constructor() {
		super("app/qualification", [], []);
	}
}

export default new QualificationAppModel();
